import { poisBountyAssets } from "assets/cdn";
import classNames from "classnames";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import { useAppDispatch, useAppSelector, useImagePath } from "hooks";
import useBreakpoints from "hooks/useBreakpoints";
import { useEffect, useMemo } from "react";
import { onClosePopUp, selectPoisBountyV3State } from "redux/slices";
import { getTimeLeft } from "utils/time";
import { Carousel, Grid, itemsV2, itemsV3 } from "../learn-more-ftue";
import {
	Alignment,
	Avatar,
	Button,
	Container,
	Copy,
	Footer,
	Head,
	Note,
	Title
} from "./styles";

interface PBFTUEV3Props {}

export const PBFTUEV3 = ({}: PBFTUEV3Props) => {
	const dispatch = useAppDispatch();
	const { getImage } = useImagePath("cdn");
	const { isSmDown } = useBreakpoints();
	const { nowTime } = useWebStoreContext();
	const scale = useCalculateScale(isSmDown ? 380 : 1010, isSmDown ? 680 : 640);
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { tracker, trackers } = useAppSelector(selectPoisBountyV3State);

	const isUserEvent = useMemo(() => {
		return trackers?.eventType === "user";
	}, [trackers?.eventType]);

	const onClose = () => {
		dispatch(onClosePopUp());
	};

	useEffect(() => {
		if (trackers?.eventId) {
			const timeLeft = getTimeLeft(nowTime, tracker?.endTime, "seconds");
			const timeTotal =
				getTimeLeft(tracker?.startTime, tracker?.endTime, "seconds") ||
				undefined;
			reportPlaygamiEvent("tp.web_frontend", {
				event_name: "tutorial_clicked",
				event_type: "pois_bounty_v3",
				action: "tutorial_clicked",
				source: "pois_bounty_menu",
				type: trackers?.eventType === "user" ? "personal" : trackers?.eventType,
				time_left: timeLeft,
				time_total: timeTotal,
				event_id: trackers.eventId
			});
		}
	}, [trackers?.eventId]);

	return (
		<Container scale={scale} className={classNames(isSmDown && "mobile")}>
			<Head background={getImage(poisBountyAssets.v3.ftue.background)}>
				{isSmDown ? (
					<Title
						className="avatar-title"
						src={getImage(poisBountyAssets.v3.ftue.logo)}
					/>
				) : (
					<Avatar
						className="avatar"
						src={getImage(poisBountyAssets.v3.ftue.logo)}
					/>
				)}
			</Head>
			<CloseIconButton onClose={onClose} />
			<Alignment className="alignment">
				<div>
					{isSmDown ? (
						<Carousel items={isUserEvent ? itemsV2 : itemsV3} />
					) : (
						<Grid items={isUserEvent ? itemsV2 : itemsV3} />
					)}
				</div>
				<Footer>
					<Copy className="copy">
						<Note className="note">Please Note:</Note>
						<br />
						<strong>
							Loyalty Points are not being deducted for Poi’s Bounty
							progression.
						</strong>
						<br />
						Only Loyalty Points accumulated during the event are counted towards
						your progression.
					</Copy>
				</Footer>
			</Alignment>
			<Button
				//className="button"
				themeColor="secondary"
				onClick={() => dispatch(onClosePopUp())}
			>
				Continue Shopping
			</Button>
		</Container>
	);
};
